import { defineComponent as a, createBlock as n, openBlock as r, unref as c, mergeProps as p, withCtx as d, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconEyeClosed",
  __name: "IconEyeClosed",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (s, l) => (r(), n(c(m), p(t, { "view-box": "0 0 24 24" }), {
      default: d(() => l[0] || (l[0] = [
        e("path", {
          "fill-rule": "evenodd",
          d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-3.774-3.774c1.787-.986 3.38-2.477 3.957-4.463a.746.746 0 0 0 .008-.439c-.576-2.016-2.197-3.525-4.01-4.515C15.892 6.285 13.77 5.75 12 5.75c-1.33 0-2.862.303-4.313.876L3.53 2.47m5.327 5.327L9.932 8.87a3.751 3.751 0 0 1 5.197 5.197l1.517 1.517a10.415 10.415 0 0 0 .346-.18c1.545-.844 2.746-2.012 3.222-3.405-.476-1.393-1.678-2.56-3.222-3.404C15.38 7.715 13.502 7.25 12 7.25c-.951 0-2.053.186-3.143.547m5.174 5.173a2.251 2.251 0 0 0-3.001-3l3 3",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M2.279 11.794c.43-1.507 1.446-2.73 2.688-3.666L6.04 9.2C4.969 9.965 4.157 10.914 3.786 12c.475 1.393 1.677 2.56 3.222 3.404 1.613.881 3.49 1.346 4.992 1.346a8.94 8.94 0 0 0 1.46-.128l1.266 1.265A11.222 11.222 0 0 1 12 18.25c-1.769 0-3.892-.535-5.711-1.53-1.805-.985-3.42-2.484-4.002-4.487a.746.746 0 0 1-.008-.439" }, null, -1),
        e("path", { d: "M9.348 14.652A3.745 3.745 0 0 1 8.29 11.45l1.945 1.945a2.268 2.268 0 0 0 .37.369l1.944 1.945a3.745 3.745 0 0 1-3.2-1.058" }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
